import script from "./HomeDocumentList.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDocumentList.vue?vue&type=script&setup=true&lang=js"

import "./HomeDocumentList.vue?vue&type=style&index=0&id=fd78d6bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd78d6bc"]])

export default __exports__